import capitalizarString from './capitalizarString.js'

export default (string) =>
	string
		.split('_')
		.map((string, index) => {
			if (index > 0) string = capitalizarString(string)
			return string
		})
		.join('')
